export default __webpack_public_path__ + "static/media/i079hp.638bfd72.webp";